import { c as _c } from "react/compiler-runtime";
import { debounce } from '@cc-shopping/utils/function/debounce';
import { Box } from '@mui/material';
import React, { type PropsWithChildren, useCallback, useEffect, useRef } from 'react';
type ResizingContainerProps = {
  maxCtaHeight: number;
  setMaxCtaHeight: (height: number) => void;
};
const ResizingContainer: React.FC<PropsWithChildren<ResizingContainerProps>> = t0 => {
  const $ = _c(16);
  const {
    children,
    maxCtaHeight,
    setMaxCtaHeight
  } = t0;
  const ctaRef = useRef(null);
  const maxCtaHeightRef = useRef(maxCtaHeight);
  let t1;
  let t2;
  if ($[0] !== maxCtaHeight) {
    t1 = () => {
      maxCtaHeightRef.current = maxCtaHeight;
    };
    t2 = [maxCtaHeight];
    $[0] = maxCtaHeight;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== setMaxCtaHeight) {
    t3 = () => {
      setMaxCtaHeight(0);
    };
    $[3] = setMaxCtaHeight;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const realignCards = t3;
  let t4;
  let t5;
  if ($[5] !== realignCards) {
    t4 = () => {
      const realignCardsDebounce = debounce(realignCards, 250);
      window.addEventListener("resize", realignCardsDebounce);
      return () => window.removeEventListener("resize", realignCardsDebounce);
    };
    t5 = [realignCards];
    $[5] = realignCards;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[8] !== setMaxCtaHeight) {
    t6 = () => {
      let resizeObserver = null;
      let rafId = null;
      rafId = requestAnimationFrame(() => {
        const element = ctaRef.current;
        if (!element) {
          return;
        }
        const updateHeight = () => {
          const height = element.clientHeight;
          if (height > maxCtaHeightRef.current) {
            setMaxCtaHeight(height);
          }
        };
        resizeObserver = new ResizeObserver(updateHeight);
        resizeObserver.observe(element);
        updateHeight();
      });
      return () => {
        if (rafId !== null) {
          cancelAnimationFrame(rafId);
        }
        resizeObserver?.disconnect();
      };
    };
    t7 = [setMaxCtaHeight];
    $[8] = setMaxCtaHeight;
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  useEffect(t6, t7);
  const t8 = `${maxCtaHeight}px`;
  let t9;
  if ($[11] !== t8) {
    t9 = {
      minHeight: t8,
      width: "100%"
    };
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== children || $[14] !== t9) {
    t10 = <Box ref={ctaRef} style={t9}>{children}</Box>;
    $[13] = children;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
};
export default ResizingContainer;